export default {
  PERSONNEL_TYPE: {
    COACHES: "COACHES",
    MANAGERS: "MANAGERS",
    MEDICAL_STAFF: "MEDICAL_STAFF",
    TEAM_STAFF: "TEAM STAFF",
    CUSTOM_STAFF: "CUSTOM STAFF"
  }
};
